import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormBaseType } from "@green0meter/api-client";
import { isEmpty } from "lodash";

import CardTable from "@components/common/CardTable";
import { DownloadButton } from "@components/common";
import { Typography } from "@components/base";
import { useGetUploadsMetadata } from "@api";
import { useUserStore } from "@store/user";
import { formatDateUtc, formatFileSize } from "@helpers";

interface VsmeMyUploads {}

const VsmeMyUploads: FC<VsmeMyUploads> = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { uploadsMetadata, uploadsMetadataEnabled, isSuccessUploads } =
    useGetUploadsMetadata(user, {
      formBaseType: FormBaseType.VSME,
    });

  const [rows, setRows] = useState<CardTable["rows"]>([]);

  const columns: CardTable["columns"] = [
    {
      field: "name",
      title: t("vsme.uploads.table.column.name"),
      tableProps: {
        sx: {
          minWidth: 180,
        },
      },
    },
    {
      field: "size",
      title: t("vsme.uploads.table.column.size"),
      tableProps: {
        width: 120,
        sx: {
          minWidth: 120,
        },
      },
    },
    {
      field: "lastModified",
      title: t("vsme.uploads.table.column.date"),
      tableProps: {
        width: 120,
        sx: {
          minWidth: 120,
        },
      },
    },
    {
      field: "action",
      title: "",
      tableProps: {
        align: "right",
      },
    },
  ];

  useEffect(() => {
    if (uploadsMetadata && !isEmpty(uploadsMetadata)) {
      const _rows = uploadsMetadata.map((upload) => ({
        name: upload.name,
        size: formatFileSize(upload.size),
        lastModified: formatDateUtc(upload.createdAt),
        action: <DownloadButton report={upload} />,
      }));

      setRows(_rows);
    }
  }, [uploadsMetadata]);

  if (!uploadsMetadataEnabled) {
    return null;
  }

  return (
    <CardTable
      title={t("vsme.uploads.title")}
      type="uploads"
      columns={columns}
      rows={rows}
      isLoaded={isSuccessUploads}
      placeholderText={
        <Typography>
          {t("vsme.uploads.placeholder.noReports")}
          <br />
          {t("vsme.uploads.placeholder.fillForm")}
        </Typography>
      }
    />
  );
};

export default VsmeMyUploads;
